<template>
  <div class="intell">
    <IntellIgent v-on:message="controlIntell" v-if="showIntell"/>
  </div>
</template>


<script>
  import IntellIgent from '../components/Intelligent.vue';

  export default {
    name: 'patients',
    components: {
      IntellIgent
    },
    data() {
      return {
        showIntell: true
      }
    },
    methods: {
      controlIntell(message) {
        switch (message.type) {
          case "newPatient":
            this.showIntell = false;
            this.$nextTick(() => {
              this.showIntell = true;
            });
            break;
        }
      }
    },
  };
</script>
<style scoped>
  .intell {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>

